// MagiaScreen.jsx
import React from "react";
import { Link } from "react-router-dom";

import { Box, Button, Container, Grid, Stack, Typography } from "@mui/material";

import Book from "../components/Book";
import portadaPC from "../imgs/PortadaPC.jpg";
import portadaCSM from "../imgs/PortadaComposicionShowsMentalismo.jpg";
import portadaOR from "../imgs/PortadaOrdenacionRadical.svg";
import MailingListForm from "../components/MailingListForm";

const books = [
    {
        image: portadaPC,
        url: "https://amzn.eu/d/dq3BYOi",
        name: "Pocket Card",
        author: "Por Alejandro Loda",
        subline: "El enfile del mentalista",
        to: "/magia/pocketcard",
    },
    {
        image: portadaCSM,
        url: "https://www.instagram.com/mago.alejandroloda",
        textInside: "Agotado",
        name: "Composición de Shows de Mentalismo",
        author: "Por Alejandro Loda",
        subline: "Agotado",
        to: "/magia/composicionsm",
    },
    {
        image: portadaOR,
        url: "https://www.instagram.com/mago.alejandroloda",
        textInside: "Próximamente",
        name: "Ordenación Radical",
        author: "Por Alejandro Loda",
        subline: "Lanzamiento en mediados de 2027",
    },
];

const MagiaScreen = () => {
    return (
        <Box
            className="text-focus-in"
            sx={{
                minHeight: "calc(100vh - 88px)",
                bgcolor: "#0a0a0a",
                backgroundImage: {
                    xs: "linear-gradient(90deg, rgba(0,0,0,.88) 0%, rgba(0,0,0,.55) 70%, rgba(0,0,0,.25) 100%), url('/images/cartaEnCopa.jpg')",
                    md: "linear-gradient(90deg, rgba(0,0,0,.82) 0%, rgba(0,0,0,.35) 48%, rgba(0,0,0,0) 72%), url('/images/cartaEnCopa.jpg')",
                },
                backgroundSize: "cover",
                // backgroundPosition: { xs: "60% center", md: "center" },
                backgroundPosition: "center 45%",
                color: "#fff",
                py: { xs: 7, md: 10 },
            }}
        >
            <Container maxWidth="xl">
                <Box sx={{ mb: { xs: 7, md: 10 } }}>
                    <Typography
                        sx={{
                            mb: 1.5,
                            fontSize: ".75rem",
                            letterSpacing: ".22em",
                            textTransform: "uppercase",
                            opacity: 0.5,
                        }}
                    >
                        Publicaciones
                    </Typography>

                    {/* <Typography
                        component="h1"
                        sx={{
                            fontSize: { xs: "2.8rem", md: "4.5rem" },
                            fontWeight: 700,
                            lineHeight: 1,
                            letterSpacing: "-.04em",
                        }}
                    >
                        Magia escrita
                    </Typography> */}

                    <Typography
                        sx={{
                            mt: 2,
                            maxWidth: 520,
                            color: "rgba(255,255,255,.55)",
                            lineHeight: 1.7,
                        }}
                    >
                        Libros, ideas y trabajos alrededor de la magia y el
                        mentalismo.
                    </Typography>
                </Box>

                <Grid container spacing={{ xs: 9, md: 7 }}>
                    {books.map(({ to, ...book }) => (
                        <Grid key={book.name} size={{ xs: 12, lg: 6 }}>
                            <Stack
                                spacing={3}
                                sx={{
                                    height: "100%",
                                    alignItems: { xs: "center", md: "stretch" },
                                }}
                            >
                                <Book {...book} />

                                {to && (
                                    <Button
                                        component={Link}
                                        to={to}
                                        variant="outlined"
                                        sx={{
                                            alignSelf: {
                                                xs: "center",
                                                md: "center",
                                            },
                                            color: "#fff",
                                            borderColor: "rgba(255,255,255,.6)",
                                            // px: 0,
                                            minWidth: 0,
                                            fontSize: ".75rem",
                                            letterSpacing: ".14em",
                                            "&:hover": {
                                                bgcolor: "transparent",
                                                opacity: 0.65,
                                            },
                                        }}
                                    >
                                        Descubre más →
                                    </Button>
                                )}
                            </Stack>
                        </Grid>
                    ))}
                </Grid>
                <br />
                <MailingListForm
                    listSlug="book-publication-ordenacion-radical"
                    eyebrow="Próximamente"
                    title={
                        <>
                            ¿Te aviso cuando se publique{" "}
                            <i>Ordenación Radical</i>?
                        </>
                    }
                    description="Déjanos tus datos y te mandaré un correo electrónico cuando el libro esté disponible."
                    buttonText="Avísame"
                    successMessage="¡Listo! Te avisaré cuando se publique el libro."
                />
            </Container>
        </Box>
    );
};

export default MagiaScreen;
